import { combineReducers } from 'redux'

import language from './language'

export default combineReducers({ language })


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js